import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import React from "react";
import { LAB_TEST_REFERENCE_VALUES } from "../../../../utils/constants/labTestReferenceValues";

const fields = [
  { key: "pus", label: "Pus", unit: "/HPF" },
  { key: "rbcs", label: "RBCs", unit: "/HPF" },
  { key: "epiCells", label: "Epithelial Cells", unit: "/HPF" },
  { key: "caOxalate", label: "Ca. Oxalate", unit: "/HPF" },
];

export default function MicroscopicTestReport({ defaultValues, reportTemplate }) {
  if (!defaultValues || Object.keys(defaultValues).length === 0) {
    return <p>डाटा उपलब्ध छैन</p>;
  }
  return (
    <TableContainer>
      <Table classes={{ root: "table-bordered" }} size="small" aria-label="Microscopic Test">
        <TableHead classes={{ root: "align-center" }}>
          <TableRow>
            <TableCell>Test</TableCell>
            <TableCell>Result</TableCell>
            <TableCell>Reference Value</TableCell>
            <TableCell>Unit</TableCell>
          </TableRow>
        </TableHead>
        <TableBody classes={{ root: "align-center" }}>
          {fields.map(({ key, label, unit }) => (
            defaultValues[key] ? (
              <TableRow key={key}>
                <TableCell>{label}</TableCell>
                <TableCell>{defaultValues[key]}</TableCell>
                <TableCell>{LAB_TEST_REFERENCE_VALUES[reportTemplate]?.[key]?.reference || "-"}</TableCell>
                <TableCell>{unit}</TableCell>
              </TableRow>
            ) : null
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
